import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateAlias = new ReduxAsyncAction<'UPDATE_ALIAS', string, { alias: string }>('UPDATE_ALIAS');

UpdateAlias.registerRequest(async (alias: string) => {
  return { alias };
});

export const UPDATE_ALIAS = UpdateAlias.actionNamespaceConstants;
export const updateAlias = UpdateAlias.request;

export type UpdateAliasResponseAction = Action<typeof UPDATE_ALIAS.response> & {
  data: { alias: string };
};
